<ng-container *ngIf="vo$ | async; let vo">
	<app-page>
		<app-page-header></app-page-header>

		<app-page-actions></app-page-actions>

		<app-page-content>
			<div class="permission-list__config">
				<mat-checkbox [(ngModel)]="config.usePanel">
					<span
						i18n="@@permission.config.usePanel">
						use-panel
					</span>
				</mat-checkbox>

				<mat-checkbox [(ngModel)]="config.inViewMode">
					<span
						i18n="@@permission.config.inViewMode">
						in-view-mode
					</span>
				</mat-checkbox>

				<mat-form-field appearance="fill">
					<mat-label
						i18n="@@permission.config.columnWidth">
						column-width</mat-label>
					<input matInput type="text" [(ngModel)]="config.columnWidth" placeholder="150">
				</mat-form-field>
			</div>

			<ng-container *ngIf="config.usePanel; else noPanel">
				<app-panel
					headerHeight="3rem"
					isAlwaysOpen="true"
					maxActionsCount="6"
					[itemsCount]="vo.list.elements.size">
					<span
						panel-title
						i18n="@@permission.list.title">
						permissions</span>

					<ng-container *ngTemplateOutlet="permissionsTpl"></ng-container>

				</app-panel>
			</ng-container>


			<ng-template #noPanel>
				<ng-container *ngTemplateOutlet="permissionsTpl"></ng-container>
			</ng-template>

			<pre class="updated-list">{{ vo.result | json }}</pre>
			</app-page-content>
	</app-page>

	<ng-template #permissionsTpl>
		<app-permissions-config
			(updatedPermissionConfig)="getResult($event)"
			[permissionsConfig]="vo.list"
			[config]="config">
		</app-permissions-config>
	</ng-template>

</ng-container>

